import React, { useState, useEffect, useCallback } from "react";
import {
  List,
  ListItemText,
  Typography,
  Divider,
  Collapse,
  Box,
  Menu,
  Chip,
  Stack,
  Button,
  Grid,
  Paper,
  MenuItem,
  Card,
  CardContent,
  ListItemIcon,
  CardActions,
  DialogActions,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { format, addHours, addMinutes, addSeconds } from "date-fns";
import zhTW from "date-fns/locale/zh-TW";
import { zhHK } from "@mui/x-date-pickers";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CheckoutDrawer from "./CheckoutDrawer";
import { useTheme, styled } from "@mui/material/styles";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import TimeMenu from "../TimeMenu";
import PromotionMenu from "../PromotionMenu";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import tableIcon from "../../icons/page_table.png";
function ReservationStep2({ nextStep, prevStep, tables, store }) {
  const theme = useTheme();
  const today = new Date();
  const [total, setTotal] = useState(0);
  const bufferTime = 0;
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedStartTime, setSelectedStartTime] = useState(new Date());
  const [selectedEndTime, setSelectedEndTime] = useState(null);
  const [selectedPriceTableIndex, setSelectedPriceTableIndex] = useState(-1);
  const [endTime, setEndTime] = useState(null);

  const [forceUpdate, setForceUpdate] = useState(0);
  const navigate = useNavigate();
  const [quantityPromotion, setQuantityPromotion] = useState([]);
  const [selectedPromotionIndex, setSelectedPromotionIndex] = useState(null);
  const [pointPromotion, setPointPromotion] = useState({
    rewardValue: 0,
    threshold: 0,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);

  const intervalMinutes = store?.IntervalMinutes || 30;
  const RewardType = {
    QUANTITY: "Quantity",
    AMOUNT: "Amount",
    POINT: "Point",
  };
  var lastReservationTime = new Date();
  const differenceInHours =
    (new Date(selectedEndTime) - new Date(selectedStartTime)) /
    (1000 * 60 * 60);
  const resetSelectedTimes = () => {
    setSelectedPromotionIndex(null);

    setSelectedEndTime(null);
  };

  const ReservationTimeline = ({ reservations }) => {
    reservations.sort((a, b) => {
      const dateA = new Date(a.StartTime);
      const dateB = new Date(b.StartTime);
      return dateA - dateB;
    });
    const currentTime = new Date();
    const hoursBeforeAfter = 240; // 12 hours before and after

    const parseDate = (dateString) => new Date(dateString);

    const formatDateTime = (dateTimeStr) => {
      const date = new Date(dateTimeStr);
      return date.toLocaleString("zh-TW", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    };
    const isToday = (date1) => {
      const tmpTime = new Date(selectedStartTime);
      const startLimit = new Date(tmpTime.setHours(0, 0, 0, 0));
      return (
        date1.getFullYear() === startLimit.getFullYear() &&
        date1.getMonth() === startLimit.getMonth() &&
        date1.getDate() === startLimit.getDate()
      );
    };
    const isWithinTimeHorizon = (startTime, endTime) => {
      const endLimit = new Date(
        currentTime.getFullYear(),
        currentTime.getMonth(),
        currentTime.getDate(),
        23,
        59,
        59,
        999
      );

      return isToday(new Date(startTime)) || isToday(new Date(endTime));
    };

    const hasReservations = reservations && reservations.length > 0;
    function isCrossDay(start, end, isFirstText) {
      if (
        start.getFullYear() !== end.getFullYear() ||
        start.getMonth() !== end.getMonth() ||
        start.getDate() !== end.getDate()
      ) {
        if (isToday(start)) {
          if (isFirstText) return "";
          return "(隔日)";
        } else if (isToday(end)) {
          if (!isFirstText) return "";
          return "(前日)";
        } else {
          return "(前日)";
        }
      } else {
        return "";
      }
    }
    return (
      hasReservations && (
        <Box
          width={"85%"}
          height={"40%"}
          bgcolor={"#ededed"}
          paddingY={2}
          marginBottom={2}
        >
          
          <Typography textAlign={"center"} fontSize={"large"} marginBottom={1}>
            已經被預約
          </Typography>
          
          {reservations
            .filter(({ StartTime, EndTime }) =>
              isWithinTimeHorizon(StartTime, EndTime)
            )
            .map((reservation, index) => {
              const startTime = addMinutes(
                new Date(reservation.StartTime),
                -bufferTime
              );
              const endTime = addMinutes(
                new Date(reservation.EndTime),
                bufferTime
              );
              const crossesDay = isCrossDay(startTime, endTime);

              return (
                <Typography textAlign={"center"} key={index} fontSize={18}>
                  {isCrossDay(startTime, endTime, true)}{" "}
                  {formatDateTime(startTime)} -{" "}
                  {isCrossDay(startTime, endTime, false)}
                  {formatDateTime(endTime)}
                </Typography>
              );
            })}
        </Box>
      )
    );
  };
  useEffect(() => {
    let quantityPromotions = [];
    for (let index = 0; index < store.Promotions?.length; index++) {
      if (store.Promotions[index].RewardType === RewardType.QUANTITY) {
        quantityPromotions.push({
          rewardValue: store.Promotions[index]?.RewardValue,
          threshold: store.Promotions[index]?.QuantityThreshold,
        });
      }
      if (store.Promotions[index].RewardType === RewardType.POINT) {
        setPointPromotion({
          rewardValue: store.Promotions[index]?.RewardValue,
          threshold: store.Promotions[index]?.AmountThreshold,
        });
      }
    }
    setQuantityPromotion(quantityPromotions);
  }, []);

  const recalculateTotal = useCallback(() => {
    if (
      selectedStartTime === null ||
      selectedItem === null ||
      selectedPriceTableIndex === -1
    ) {
      setSelectedEndTime(null);
      setTotal(0);
      return;
    }

    const totalHours =
      tables[selectedItem]?.PriceTable.Hour[selectedPriceTableIndex] +
      tables[selectedItem]?.PriceTable.FreeHour[selectedPriceTableIndex];
    const startTime = new Date(selectedStartTime);
    const hours = Math.floor(totalHours);
    const minutes = (totalHours - hours) * 60;
    const finalPrice =
      tables[selectedItem]?.PriceTable.Price[selectedPriceTableIndex] -
      tables[selectedItem]?.PriceTable.Discount[selectedPriceTableIndex];

    startTime.setHours(
      startTime.getHours() + hours,
      startTime.getMinutes() + minutes
    );

    setSelectedEndTime(startTime);
    setTotal(Math.max(finalPrice, 0));
  }, [selectedStartTime, selectedItem, selectedPriceTableIndex, tables]);

  useEffect(() => {
    recalculateTotal();
  }, [recalculateTotal, forceUpdate]); // Including forceUpdate in dependencies

  const handleSelectPriceTableIndex = (index) => {
    setSelectedPriceTableIndex(index);
    setForceUpdate((prev) => prev + 1); // Increment to force re-run of effect
  };
  const TagChip = ({ table }) => {
    const theme = useTheme();

    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, marginTop: 1 }}>
        {table.Tags?.map((tag, i) => (
          <Typography
            key={`tableTag-${i}`}
            border={2}
            color={theme.palette.text.blue}
            borderRadius={1}
            paddingX={1}
            borderColor={theme.palette.text.blue}
            sx={{
              whiteSpace: "nowrap", // Prevent text wrapping
              overflow: "hidden", // Hide overflow text
              textOverflow: "ellipsis", // Add ellipsis for overflow text
              flexShrink: 0, // Prevent flex items from shrinking
            }}
          >
            {` ${tag} `}
          </Typography>
        ))}
      </Box>
    );
  };
  const RenderInUseChip = ({ reservations }) => {
    const now = new Date(); // Get the current time
    let generated = false;

    return reservations
      ?.map((res, i) => {
        // Check if the current time is within the reservation period
        const startTime = new Date(res.StartTime);
        const endTime = new Date(res.EndTime);

        if (now >= startTime && now <= endTime && !generated) {
          generated = true;
          return (
            <Typography
              key={`quantity-${1}`}
              border={2}
              fontWeight={550}
              bgcolor={theme.palette.text.blue}
              color={theme.palette.text.selected}
              borderRadius={1}
              paddingX={1}
              borderColor={theme.palette.text.blue}
              sx={{
                whiteSpace: "nowrap", // Prevent text wrapping
              }}
            >
              使用中
            </Typography>
          );
        }
        return null; // Do not render a Chip if the current time is not within the reservation period
      })
      .filter((chip) => chip !== null); // Filter out nulls to avoid rendering empty slots
  };
  const chipColor = (time, isText) => {
    if (isTimeSelected(time)) {
      return isText ? theme.palette.text.selected : theme.palette.selected;
    }
    if (isTimeWithinSelectedPeriod(time)) {
      return isText ? theme.palette.text.selected : theme.palette.selected;
    }

    return "";
  };

  const isTimeWithinSelectedPeriod = (time) => {
    if (selectedStartTime && selectedEndTime) {
      return time >= selectedStartTime && time <= selectedEndTime;
    }

    return false;
  };
  const isTimeSelected = (time) => {
    const dateString = selectedStartTime?.toLocaleString();

    return dateString === time.toLocaleString();
  };

  const handleTableClick = (index) => {
    if (selectedItem === index) {
      setSelectedItem(null); // close the item if it's already open
      resetSelectedTimes();
    } else {
      resetSelectedTimes();
      setSelectedStartTime(today);
      setSelectedItem(index);
    }
  };

  const getInitialOffset = (date) => {
    const minutes = date.getMinutes();
    return minutes < intervalMinutes ? intervalMinutes - minutes : 60 - minutes;
  };
  const isTimeReserved = (ptime, type) => {
    // Check if Reservations array exists and is not empty
    const time = new Date(ptime.setMilliseconds(0)).setSeconds(0);
    if (
      !tables[selectedItem]?.Reservations ||
      tables[selectedItem].Reservations.length === 0
    ) {
      return false; // Return false or appropriate value if Reservations is undefined or empty
    }
    let startTime = selectedStartTime;
    if (type === "hour") startTime = time;
    if (type === "minute") startTime = time;
    for (let reservation of tables[selectedItem].Reservations) {
      const rStartTime = new Date(reservation.StartTime);
      const rEndTime = new Date(reservation.EndTime);
      // Subtract 30 minutes from startTime
      rStartTime?.setMinutes(rStartTime?.getMinutes() - bufferTime);
      // Add 30 minutes to endTime
      rEndTime?.setMinutes(rEndTime?.getMinutes() + bufferTime);
      if (
        (startTime < rEndTime && time > rStartTime) ||
        startTime === rStartTime ||
        time === rEndTime
      )
        return true;
    }

    return false;
  };

  const TimeButton = React.memo(
    ({ time, isReserved, reservations, handleClick, isTimeBonus, theme }) => {
      return (
        <MenuItem
          disabled={isReserved}
          onClick={() => handleClick(time, reservations)}
          style={{
            backgroundColor: isReserved ? "gray" : "",
          }}
          sx={{
            "&:focus": {
              backgroundColor: theme.palette.selected,
              color: theme.palette.text.selected,
            },

            bgcolor: chipColor(time, false),

            color: chipColor(time, true),
          }}
        >
          {format(time, "MM/dd HH:mm")}
        </MenuItem>
      );
    }
  );

  // Helper function to map day of the week to Chinese character
  const getDayInChinese = (date) => {
    const days = ["日", "一", "二", "三", "四", "五", "六"];
    const day = date.getDay();
    return days[day];
  };

  // Format function
  const formatDateToCustomString = (date) => {
    if (!(date instanceof Date)) {
      return "未選擇";
    }

    const monthDay = format(date, "MM/dd HH:mm", { locale: zhTW });
    const chineseDay = getDayInChinese(date);

    return `${monthDay}(${chineseDay})`;
  };

  // Calculate the date a month from now
  const oneMonthFromNow = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    today.getDate()
  );
  return (
    <Box width={"100%"}>
      <div style={{ paddingBottom: "100px" }}>


        {!tables || tables.length === 0 ? (
          <Box
            width={"100%"}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            sx={{ textAlign: "center" }}
            marginTop={10}
          >
            <Typography
              fontSize={"h5.fontSize"}
              fontWeight={"bold"}
              align="center"
              gutterBottom
            >
              請先登入才能查看。
            </Typography>
            <Button
              variant="contained"
              sx={{ width: "40%", fontSize: "20px", fontWeight: "bold" }}
              color="primary"
              onClick={() => navigate("/app")}
            >
              回首頁
            </Button>
          </Box>
        ) : null}
        {tables !== undefined && (
          <Stack>
            {tables.map((table, index) => (
              <Card
                key={"card" + index}
                elevation={0}
                sx={{ marginBottom: 1, marginX: 1, borderRadius: 2 }}
              >
                <React.Fragment key={table.code || index}>
                  <CardActions
                    sx={{
                      
                      justifyContent: "space-between",
                      backgroundColor:
                        selectedItem === index
                          ? theme.palette.selected
                          : "transparent",
                      color:
                        selectedItem === index
                          ? theme.palette.text.primary
                          : "inherit",
                    }}
                    onClick={() => handleTableClick(index)}
                  >
                    <Box flexDirection={"column"} width={'95%'}>
                      <Stack
                        direction={"row"}
                        display={"flex"}
                        alignItems="end"
                        justifyContent={"space-between"}
                      >
                        <Box
                          component="img"
                          src={tableIcon}
                          sx={{ width: "30px", marginRight: 1 }} // Add margin to the right for spacing
                        />
                        <Typography
                          fontSize={"large"}
                          sx={{
                            paddingRight: 1,
                            color:
                              selectedItem === index
                                ? theme.palette.text.primary
                                : theme.palette.text.primary,
                            fontWeight: "bold",
                            flexGrow: 2, // Allow Typography to take available space
                            whiteSpace: "nowrap", // Prevent text wrapping
                            overflow: "hidden", // Hide overflow text
                            textOverflow: "ellipsis", // Add ellipsis for overflow text
                            display: "flex", // Use flex to align items horizontally
                          }}
                        >
                          {table.Name}
                        </Typography>

                        <RenderInUseChip reservations={table.Reservations} />
                      </Stack>
                      {table.Tags?.length >0? <Divider sx={{marginY:1}} orientation="horizontal" flexItem></Divider>:<></>}
                      <TagChip table={table} />
                    </Box>

                    <Stack
                      direction={"row"}
                      display={"flex"}
                      alignItems={"center"}
                      sx={{
                        color:
                          selectedItem === index
                            ? theme.palette.text.selected
                            : theme.palette.text.primary,
                        height: "5vh",
                      }}
                    >
                      {selectedItem === index ? (
                        <ExpandLess color="secondary" />
                      ) : (
                        <ExpandMore />
                      )}
                    </Stack>
                  </CardActions>
                  <Collapse
                    in={selectedItem === index}
                    timeout="auto"
                    unmountOnExit
                  >
                    <CardContent component="div">
                      {selectedItem === index && (
                        <Stack
                          sx={{ boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" }}
                          direction={"column"}
                          alignItems={"center"}
                          display={"flex"}
                        >
                          <Stack
                            marginTop={3}
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <LooksOneIcon
                              sx={{ color: theme.palette.text.blue }}
                              fontSize={"medium"}
                            />
                            <Typography fontWeight={"bold"} fontSize={18}>
                              {"選擇日期"}
                            </Typography>
                          </Stack>

                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            localeText={
                              zhHK.components.MuiLocalizationProvider
                                .defaultProps.localeText
                            }
                            adapterLocale={zhTW}
                          >
                            <StaticDatePicker
                              sx={{
                                ".MuiPickersDay-root": {
                                  border: "0px solid",
                                },
                                ".MuiPickersDay-root.Mui-selected": {
                                  backgroundColor: theme.palette.text.blue,
                                  color: theme.palette.text.selected,

                                  border: "1px solid",
                                },
                              }}
                              views={["month", "day"]}
                              displayStaticWrapperAs="desktop"
                              name="StartDate"
                              dayOfWeekFormatter={(_day, date) => {
                                format(date, "EEEEEE");
                              }}
                              format="yyyy/MM/dd"
                              minDate={today} // Set the minimum date to today
                              maxDate={oneMonthFromNow} // Set the maximum date to a month from today
                              defaultValue={today}
                              value={selectedStartTime}
                              onChange={(newValue) => {
                                setSelectedStartTime(newValue);
                              }}
                            />
                          </LocalizationProvider>
                          <ReservationTimeline
                            reservations={table.Reservations}
                          ></ReservationTimeline>
                        </Stack>
                      )}

                      <Stack
                        sx={{ boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" }}
                        paddingY={5}
                        direction={"column"}
                        alignItems={"center"}
                        display={"flex"}
                      >
                        <Stack
                          marginBottom={2}
                          direction="row"
                          alignItems="flex-start"
                          spacing={1}
                        >
                          <LooksTwoIcon
                            sx={{ color: theme.palette.text.blue }}
                            fontSize={"medium"}
                          />
                          <Typography fontWeight={"bold"} fontSize={18}>
                            {"選擇時間"}
                          </Typography>
                        </Stack>
                        <TimeMenu
                          selectedTime={selectedStartTime}
                          setSelectedTime={setSelectedStartTime}
                          isTimeReserved={isTimeReserved}
                        ></TimeMenu>
                      </Stack>
                      <Stack
                        sx={{ boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" }}
                        paddingY={5}
                        direction={"column"}
                        alignItems={"center"}
                        display={"flex"}
                      >
                        <Stack
                          marginBottom={2}
                          direction="row"
                          alignItems="flex-start"
                          spacing={1}
                        >
                          <Looks3Icon
                            sx={{ color: theme.palette.text.blue }}
                            fontSize={"medium"}
                          />
                          <Typography
                            marginY={1}
                            fontWeight={"bold"}
                            fontSize={18}
                          >
                            {"使用時間"}
                          </Typography>
                        </Stack>

                        <PromotionMenu
                          priceTable={table.PriceTable}
                          selectedStartTime={selectedStartTime}
                          handleSelectPriceTableIndex={
                            handleSelectPriceTableIndex
                          }
                          isTimeReserved={isTimeReserved}
                        ></PromotionMenu>
                      </Stack>
                    </CardContent>
                  </Collapse>
                  <Divider />
                </React.Fragment>
              </Card>
            ))}
          </Stack>
        )}
        <CheckoutDrawer
          storeName={store.Name}
          table={
            selectedItem !== undefined || null ? tables[selectedItem] : null
          }
          total={total}
          startTime={selectedStartTime}
          endTime={selectedEndTime}
          priceIndex={selectedPriceTableIndex}
          nextStep={nextStep}
          onlinePaymentAvailable={store.OnlinePaymentAvailable}
          invoiceEnable={store.InvoiceEnable}
          invoiceLoveCodes={store.InvoiceLoveCodes || []}
          invoiceLoveCodeNames={store.InvoiceLoveCodeNames || {}}
        />
      </div>
    </Box>
  );
}

export default ReservationStep2;
